import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("mce_token", data.token);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-4 grain relative">
      <div className="w-full max-w-sm border border-[#C9A55C]/25 bg-[#0D1018] p-10" data-testid="admin-login-card">
        <p className="font-display text-2xl tracking-[0.15em] text-[#F3EEE5]">MEGA</p>
        <p className="text-[0.55rem] tracking-[0.4em] text-[#C9A55C] uppercase mt-1 mb-8">Admin Studio</p>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <input className="lux-input" type="email" placeholder="Email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" />
          <input className="lux-input" type="password" placeholder="Password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" />
          {error && <p className="text-xs text-red-400" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} className="btn-gold w-full justify-center disabled:opacity-60" data-testid="admin-login-submit-btn">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </main>
  );
}
